import { render } from "./Sidebar.vue?vue&type=template&id=06efe82e&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=06efe82e&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=06efe82e&lang=css"
script.render = render
script.__scopeId = "data-v-06efe82e"

export default script